import { connect } from 'react-redux';
import { StoreState } from '../../../../reducers';

import ListItem from '../../../../components/ImportDesktopFile/Toast/ListItem';

const mapStateToProps = (state: StoreState, ownProps) => {
	const {
		importManager: { byId },
	} = state;

	return {
		file: byId[ownProps.id],
	};
};

export default connect(mapStateToProps)(ListItem);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/containers/ImportDesktopFile/Toast/ListItem/index.tsx